import { Pannel, Province } from "./canvasTypes";

export const glassList36H: Pannel[] = [
  {
    length: 7.9,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 55],
    ]),
  },
  {
    length: 8.9,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 56],
    ]),
  },
  {
    length: 9.8,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 57],
    ]),
  },
  {
    length: 10.9,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 60],
    ]),
  },
  {
    length: 11.8,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 63],
    ]),
  },
  {
    length: 13.8,
    price: new Map([
      [Province.Quebec, 36],
      [Province.Ontario, 66],
    ]),
  },
  {
    length: 15.7,
    price: new Map([
      [Province.Quebec, 37],
      [Province.Ontario, 69],
    ]),
  },
  {
    length: 17.7,
    price: new Map([
      [Province.Quebec, 44],
      [Province.Ontario, 72],
    ]),
  },
  {
    length: 19.7,
    price: new Map([
      [Province.Quebec, 45],
      [Province.Ontario, 77],
    ]),
  },
  {
    length: 21.7,
    price: new Map([
      [Province.Quebec, 46],
      [Province.Ontario, 80],
    ]),
  },
  {
    length: 23.6,
    price: new Map([
      [Province.Quebec, 47],
      [Province.Ontario, 85],
    ]),
  },
  {
    length: 25.6,
    price: new Map([
      [Province.Quebec, 55],
      [Province.Ontario, 90],
    ]),
  },
  {
    length: 27.6,
    price: new Map([
      [Province.Quebec, 56],
      [Province.Ontario, 95],
    ]),
  },
  {
    length: 29.5,
    price: new Map([
      [Province.Quebec, 57],
      [Province.Ontario, 100],
    ]),
  },
  {
    length: 31.5,
    price: new Map([
      [Province.Quebec, 67],
      [Province.Ontario, 105],
    ]),
  },
  {
    length: 33.5,
    price: new Map([
      [Province.Quebec, 75],
      [Province.Ontario, 110],
    ]),
  },
  {
    length: 35.4,
    price: new Map([
      [Province.Quebec, 76],
      [Province.Ontario, 115],
    ]),
  },
  {
    length: 37.4,
    price: new Map([
      [Province.Quebec, 77],
      [Province.Ontario, 120],
    ]),
  },
  {
    length: 39.4,
    price: new Map([
      [Province.Quebec, 95],
      [Province.Ontario, 125],
    ]),
  },
  {
    length: 41.3,
    price: new Map([
      [Province.Quebec, 96],
      [Province.Ontario, 127],
    ]),
  },
  {
    length: 43.3,
    price: new Map([
      [Province.Quebec, 97],
      [Province.Ontario, 130],
    ]),
  },
  {
    length: 45.3,
    price: new Map([
      [Province.Quebec, 98],
      [Province.Ontario, 134],
    ]),
  },
  {
    length: 47.2,
    price: new Map([
      [Province.Quebec, 101],
      [Province.Ontario, 138],
    ]),
  },
  {
    length: 49.2,
    price: new Map([
      [Province.Quebec, 106],
      [Province.Ontario, 142],
    ]),
  },
  {
    length: 51.2,
    price: new Map([
      [Province.Quebec, 108],
      [Province.Ontario, 145],
    ]),
  },
  {
    length: 53.1,
    price: new Map([
      [Province.Quebec, 109],
      [Province.Ontario, 147],
    ]),
  },
  {
    length: 55.1,
    price: new Map([
      [Province.Quebec, 116],
      [Province.Ontario, 150],
    ]),
  },
  {
    length: 57.7,
    price: new Map([
      [Province.Quebec, 119],
      [Province.Ontario, 153],
    ]),
  },
  {
    length: 59.1,
    price: new Map([
      [Province.Quebec, 126],
      [Province.Ontario, 157],
    ]),
  },
  {
    length: 61,
    price: new Map([
      [Province.Quebec, 129],
      [Province.Ontario, 160],
    ]),
  },
  {
    length: 63,
    price: new Map([
      [Province.Quebec, 139],
      [Province.Ontario, 200],
    ]),
  },
  {
    length: 65,
    price: new Map([
      [Province.Quebec, 146],
      [Province.Ontario, 210],
    ]),
  },
  {
    length: 66.9,
    price: new Map([
      [Province.Quebec, 149],
      [Province.Ontario, 220],
    ]),
  },
  {
    length: 68.9,
    price: new Map([
      [Province.Quebec, 156],
      [Province.Ontario, 235],
    ]),
  },
  {
    length: 70.9,
    price: new Map([
      [Province.Quebec, 158],
      [Province.Ontario, 250],
    ]),
  },
  {
    length: 72.8,
    price: new Map([
      [Province.Quebec, 159],
      [Province.Ontario, 260],
    ]),
  },
];

export const glassList42H: Pannel[] = [
  {
    length: 7.9,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 65],
    ]),
  },
  {
    length: 8.9,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 66],
    ]),
  },
  {
    length: 9.8,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 67],
    ]),
  },
  {
    length: 10.9,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 70],
    ]),
  },
  {
    length: 11.8,
    price: new Map([
      [Province.Quebec, 36],
      [Province.Ontario, 75],
    ]),
  },
  {
    length: 13.8,
    price: new Map([
      [Province.Quebec, 37],
      [Province.Ontario, 80],
    ]),
  },
  {
    length: 15.7,
    price: new Map([
      [Province.Quebec, 38],
      [Province.Ontario, 85],
    ]),
  },
  {
    length: 17.7,
    price: new Map([
      [Province.Quebec, 48],
      [Province.Ontario, 90],
    ]),
  },
  {
    length: 19.7,
    price: new Map([
      [Province.Quebec, 49],
      [Province.Ontario, 93],
    ]),
  },
  {
    length: 21.7,
    price: new Map([
      [Province.Quebec, 57],
      [Province.Ontario, 96],
    ]),
  },
  {
    length: 23.6,
    price: new Map([
      [Province.Quebec, 58],
      [Province.Ontario, 100],
    ]),
  },
  {
    length: 25.6,
    price: new Map([
      [Province.Quebec, 69],
      [Province.Ontario, 105],
    ]),
  },
  {
    length: 27.6,
    price: new Map([
      [Province.Quebec, 74],
      [Province.Ontario, 110],
    ]),
  },
  {
    length: 29.5,
    price: new Map([
      [Province.Quebec, 76],
      [Province.Ontario, 112],
    ]),
  },
  {
    length: 31.5,
    price: new Map([
      [Province.Quebec, 79],
      [Province.Ontario, 115],
    ]),
  },
  {
    length: 33.5,
    price: new Map([
      [Province.Quebec, 84],
      [Province.Ontario, 120],
    ]),
  },
  {
    length: 35.4,
    price: new Map([
      [Province.Quebec, 86],
      [Province.Ontario, 130],
    ]),
  },
  {
    length: 37.4,
    price: new Map([
      [Province.Quebec, 89],
      [Province.Ontario, 135],
    ]),
  },
  {
    length: 39.4,
    price: new Map([
      [Province.Quebec, 96],
      [Province.Ontario, 140],
    ]),
  },
  {
    length: 41.3,
    price: new Map([
      [Province.Quebec, 99],
      [Province.Ontario, 145],
    ]),
  },
  {
    length: 43.3,
    price: new Map([
      [Province.Quebec, 106],
      [Province.Ontario, 148],
    ]),
  },
  {
    length: 45.3,
    price: new Map([
      [Province.Quebec, 109],
      [Province.Ontario, 152],
    ]),
  },
  {
    length: 47.2,
    price: new Map([
      [Province.Quebec, 116],
      [Province.Ontario, 155],
    ]),
  },
  {
    length: 49.2,
    price: new Map([
      [Province.Quebec, 119],
      [Province.Ontario, 157],
    ]),
  },
  {
    length: 51.2,
    price: new Map([
      [Province.Quebec, 126],
      [Province.Ontario, 160],
    ]),
  },
  {
    length: 53.1,
    price: new Map([
      [Province.Quebec, 129],
      [Province.Ontario, 163],
    ]),
  },
  {
    length: 55.1,
    price: new Map([
      [Province.Quebec, 136],
      [Province.Ontario, 165],
    ]),
  },
  {
    length: 57.7,
    price: new Map([
      [Province.Quebec, 139],
      [Province.Ontario, 167],
    ]),
  },
  {
    length: 59.1,
    price: new Map([
      [Province.Quebec, 146],
      [Province.Ontario, 170],
    ]),
  },
  {
    length: 61,
    price: new Map([
      [Province.Quebec, 149],
      [Province.Ontario, 180],
    ]),
  },
  {
    length: 63,
    price: new Map([
      [Province.Quebec, 156],
      [Province.Ontario, 200],
    ]),
  },
  {
    length: 65,
    price: new Map([
      [Province.Quebec, 159],
      [Province.Ontario, 215],
    ]),
  },
  {
    length: 66.9,
    price: new Map([
      [Province.Quebec, 169],
      [Province.Ontario, 225],
    ]),
  },
  {
    length: 68.9,
    price: new Map([
      [Province.Quebec, 174],
      [Province.Ontario, 245],
    ]),
  },
  {
    length: 70.9,
    price: new Map([
      [Province.Quebec, 176],
      [Province.Ontario, 275],
    ]),
  },
  {
    length: 72.8,
    price: new Map([
      [Province.Quebec, 179],
      [Province.Ontario, 285],
    ]),
  },
];

export const glassList48H: Pannel[] = [
  {
    length: 7.9,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 75],
    ]),
  },
  {
    length: 8.9,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 76],
    ]),
  },
  {
    length: 9.8,
    price: new Map([
      [Province.Quebec, 35],
      [Province.Ontario, 77],
    ]),
  },
  {
    length: 10.9,
    price: new Map([
      [Province.Quebec, 37],
      [Province.Ontario, 80],
    ]),
  },
  {
    length: 11.8,
    price: new Map([
      [Province.Quebec, 38],
      [Province.Ontario, 83],
    ]),
  },
  {
    length: 13.8,
    price: new Map([
      [Province.Quebec, 39],
      [Province.Ontario, 85],
    ]),
  },
  {
    length: 15.7,
    price: new Map([
      [Province.Quebec, 48],
      [Province.Ontario, 87],
    ]),
  },
  {
    length: 17.7,
    price: new Map([
      [Province.Quebec, 49],
      [Province.Ontario, 92],
    ]),
  },
  {
    length: 19.7,
    price: new Map([
      [Province.Quebec, 59],
      [Province.Ontario, 95],
    ]),
  },
  {
    length: 21.7,
    price: new Map([
      [Province.Quebec, 65],
      [Province.Ontario, 100],
    ]),
  },
  {
    length: 23.6,
    price: new Map([
      [Province.Quebec, 69],
      [Province.Ontario, 105],
    ]),
  },
  {
    length: 25.6,
    price: new Map([
      [Province.Quebec, 76],
      [Province.Ontario, 110],
    ]),
  },
  {
    length: 27.6,
    price: new Map([
      [Province.Quebec, 78],
      [Province.Ontario, 112],
    ]),
  },
  {
    length: 29.5,
    price: new Map([
      [Province.Quebec, 79],
      [Province.Ontario, 115],
    ]),
  },
  {
    length: 31.5,
    price: new Map([
      [Province.Quebec, 89],
      [Province.Ontario, 120],
    ]),
  },
  {
    length: 33.5,
    price: new Map([
      [Province.Quebec, 96],
      [Province.Ontario, 125],
    ]),
  },
  {
    length: 35.4,
    price: new Map([
      [Province.Quebec, 99],
      [Province.Ontario, 135],
    ]),
  },
  {
    length: 37.4,
    price: new Map([
      [Province.Quebec, 108],
      [Province.Ontario, 145],
    ]),
  },
  {
    length: 39.4,
    price: new Map([
      [Province.Quebec, 109],
      [Province.Ontario, 150],
    ]),
  },
  {
    length: 41.3,
    price: new Map([
      [Province.Quebec, 118],
      [Province.Ontario, 155],
    ]),
  },
  {
    length: 43.3,
    price: new Map([
      [Province.Quebec, 119],
      [Province.Ontario, 160],
    ]),
  },
  {
    length: 45.3,
    price: new Map([
      [Province.Quebec, 128],
      [Province.Ontario, 165],
    ]),
  },
  {
    length: 47.2,
    price: new Map([
      [Province.Quebec, 129],
      [Province.Ontario, 170],
    ]),
  },
  {
    length: 49.2,
    price: new Map([
      [Province.Quebec, 139],
      [Province.Ontario, 175],
    ]),
  },
  {
    length: 51.2,
    price: new Map([
      [Province.Quebec, 146],
      [Province.Ontario, 180],
    ]),
  },
  {
    length: 53.1,
    price: new Map([
      [Province.Quebec, 149],
      [Province.Ontario, 185],
    ]),
  },
  {
    length: 55.1,
    price: new Map([
      [Province.Quebec, 156],
      [Province.Ontario, 190],
    ]),
  },
  {
    length: 57.7,
    price: new Map([
      [Province.Quebec, 159],
      [Province.Ontario, 195],
    ]),
  },
  {
    length: 59.1,
    price: new Map([
      [Province.Quebec, 165],
      [Province.Ontario, 200],
    ]),
  },
  {
    length: 61,
    price: new Map([
      [Province.Quebec, 169],
      [Province.Ontario, 205],
    ]),
  },
  {
    length: 63,
    price: new Map([
      [Province.Quebec, 179],
      [Province.Ontario, 215],
    ]),
  },
  {
    length: 65,
    price: new Map([
      [Province.Quebec, 187],
      [Province.Ontario, 220],
    ]),
  },
  {
    length: 66.9,
    price: new Map([
      [Province.Quebec, 189],
      [Province.Ontario, 230],
    ]),
  },
  {
    length: 68.9,
    price: new Map([
      [Province.Quebec, 198],
      [Province.Ontario, 260],
    ]),
  },
  {
    length: 70.9,
    price: new Map([
      [Province.Quebec, 208],
      [Province.Ontario, 280],
    ]),
  },
  {
    length: 72.8,
    price: new Map([
      [Province.Quebec, 209.0],
      [Province.Ontario, 299],
    ]),
  },
];

// R pannels:
export const glassList48R:  Pannel[] = [
  {
    length: 11.8,
    price: new Map([
      [Province.Quebec, 115],
      [Province.Ontario, 115],
    ]),
    isRPannel: true,
  },
  {
    length: 13.8,
    price: new Map([
      [Province.Quebec, 120],
      [Province.Ontario, 120],
    ]),
    isRPannel: true,
  },
  {
    length: 15.7,
    price: new Map([
      [Province.Quebec, 130],
      [Province.Ontario, 130],
    ]),
    isRPannel: true,
  },
  {
    length: 17.7,
    price: new Map([
      [Province.Quebec, 135],
      [Province.Ontario, 135],
    ]),
    isRPannel: true,
  },
  {
    length: 19.7,
    price: new Map([
      [Province.Quebec, 140],
      [Province.Ontario, 140],
    ]),
    isRPannel: true,
  },
  {
    length: 21.7,
    price: new Map([
      [Province.Quebec, 145],
      [Province.Ontario, 145],
    ]),
    isRPannel: true,
  },
  {
    length: 23.6,
    price: new Map([
      [Province.Quebec, 150],
      [Province.Ontario, 150],
    ]),
    isRPannel: true,
  },
  {
    length: 25.6,
    price: new Map([
      [Province.Quebec, 155],
      [Province.Ontario, 155],
    ]),
    isRPannel: true,
  },
  {
    length: 27.6,
    price: new Map([
      [Province.Quebec, 157],
      [Province.Ontario, 157],
    ]),
    isRPannel: true,
  },
  {
    length: 29.5,
    price: new Map([
      [Province.Quebec, 159],
      [Province.Ontario, 159],
    ]),
    isRPannel: true,
  },
  {
    length: 31.5,
    price: new Map([
      [Province.Quebec, 161],
      [Province.Ontario, 161],
    ]),
    isRPannel: true,
  },
  {
    length: 33.5,
    price: new Map([
      [Province.Quebec, 162],
      [Province.Ontario, 162],
    ]),
    isRPannel: true,
  },
  {
    length: 35.4,
    price: new Map([
      [Province.Quebec, 165],
      [Province.Ontario, 165],
    ]),
    isRPannel: true,
  },
  {
    length: 37.4,
    price: new Map([
      [Province.Quebec, 171],
      [Province.Ontario, 171],
    ]),
    isRPannel: true,
  },
  {
    length: 39.4,
    price: new Map([
      [Province.Quebec, 174],
      [Province.Ontario, 174],
    ]),
    isRPannel: true,
  },
  {
    length: 41.3,
    price: new Map([
      [Province.Quebec, 180],
      [Province.Ontario, 180],
    ]),
    isRPannel: true,
  },
  {
    length: 43.3,
    price: new Map([
      [Province.Quebec, 184],
      [Province.Ontario, 184],
    ]),
    isRPannel: true,
  },
  {
    length: 45.3,
    price: new Map([
      [Province.Quebec, 189],
      [Province.Ontario, 189],
    ]),
    isRPannel: true,
  },
  {
    length: 47.2,
    price: new Map([
      [Province.Quebec, 192],
      [Province.Ontario, 192],
    ]),
    isRPannel: true,
  },
  {
    length: 49.2,
    price: new Map([
      [Province.Quebec, 196],
      [Province.Ontario, 196],
    ]),
    isRPannel: true,
  },
  {
    length: 51.2,
    price: new Map([
      [Province.Quebec, 200],
      [Province.Ontario, 200],
    ]),
    isRPannel: true,
  },
  {
    length: 53.1,
    price: new Map([
      [Province.Quebec, 202],
      [Province.Ontario, 202],
    ]),
    isRPannel: true,
  },
  {
    length: 55.1,
    price: new Map([
      [Province.Quebec, 206],
      [Province.Ontario, 206],
    ]),
    isRPannel: true,
  },
  {
    length: 57.7,
    price: new Map([
      [Province.Quebec, 211],
      [Province.Ontario, 211],
    ]),
    isRPannel: true,
  },
  {
    length: 59.1,
    price: new Map([
      [Province.Quebec, 216],
      [Province.Ontario, 216],
    ]),
    isRPannel: true,
  },
  {
    length: 61,
    price: new Map([
      [Province.Quebec, 218],
      [Province.Ontario, 218],
    ]),
    isRPannel: true,
  },
  {
    length: 63,
    price: new Map([
      [Province.Quebec, 222],
      [Province.Ontario, 222],
    ]),
    isRPannel: true,
  },
  {
    length: 65,
    price: new Map([
      [Province.Quebec, 227],
      [Province.Ontario, 227],
    ]),
    isRPannel: true,
  },
  {
    length: 66.9,
    price: new Map([
      [Province.Quebec, 231],
      [Province.Ontario, 231],
    ]),
    isRPannel: true,
  },
  {
    length: 68.9,
    price: new Map([
      [Province.Quebec, 236],
      [Province.Ontario, 236],
    ]),
    isRPannel: true,
  },
];

export const glassListOtherR: Pannel[] = [
  {
    length: 35.4,
    price: new Map([
      [Province.Quebec, 150],
      [Province.Ontario, 180],
    ]),
    isRPannel: true,
  },
];

export const doorCost = new Map([
  [Province.Quebec, 160],
  [Province.Ontario, 180],
]);

export const DOOR_WIDTH = 36;